// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"createLiveSession_scrollbar__QmNlT","date":"createLiveSession_date__bLlCR"};